<script>
  import { onMount } from 'svelte';
  import { Navigation, Pagination } from 'swiper';
  import SwiperNav from '$lib/swiper/Nav.svelte';
  import SwiperPagination from '$lib/swiper/Pagination.svelte';
  import Quote from '../Quote.svelte';

  export let quotes;
  let swiperEl, paginationEl, navPrevEl, navNextEl;

  onMount(() => {
    Object.assign(swiperEl, {
      modules: [Navigation, Pagination],
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        prevEl: navPrevEl,
        nextEl: navNextEl,
      },
    });

    swiperEl.initialize();
  });
</script>

<section class="quotes">
  {#if quotes.length > 1}
    <div class="quotes__nav">
      <SwiperNav bind:prev={navPrevEl} bind:next={navNextEl} />
    </div>
  {/if}
  <swiper-container bind:this={swiperEl} init={false}>
    {#each quotes as quote}
      <swiper-slide class="quotes__slide">
        <Quote text={quote.text} author={quote.author} />
      </swiper-slide>
    {/each}
  </swiper-container>
  {#if quotes.length > 1}
    <div class="quotes__pagination">
      <SwiperPagination bind:element={paginationEl} />
    </div>
  {/if}
  <!-- {:else}
    <Quote text={quotes[0].text} author={quotes[0].author} />
  {/if} -->
</section>

<style lang="scss">
  .quotes {
    margin: 0 auto;
    position: relative;
    text-align: center;
    padding-top: 0;

    @include resp-max('m') {
      padding-right: 0;
      padding-left: 0;
    }

    &__nav {
      position: absolute;
      width: calc(100% - 21.2rem);
      left: 10.6rem;
      top: 25rem;
      margin: 0 auto;

      @include resp-max('m') {
        width: calc(100% - 10rem);
        left: 5rem;
      }

      @include resp-max('s') {
        display: none;
      }
    }
    &__pagination {
      margin-top: -8rem;
    }
  }
</style>
